import { render, staticRenderFns } from "./TextareaWidget.vue?vue&type=template&id=0bd5b220&scoped=true&"
import script from "./TextareaWidget.vue?vue&type=script&lang=js&"
export * from "./TextareaWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd5b220",
  null
  
)

export default component.exports